import 'normalize.css';
import '../scss/main.scss';

import '../images/logo.svg';
import '../images/account.svg';
import '../images/footer-bg.png';
import '../images/360.png';
import '../images/background-iframe.jpg';

import ScrollClasses from './scrollclasses';
import VanilleLightbox from 'vanillelightbox';
import Marzipano from 'marzipano';
import Tabs from './tabs';

// TODO: remove globals
window.LightBox = VanilleLightbox;

window.Tabs = Tabs;

window.addEventListener('DOMContentLoaded', function(){
	new ScrollClasses(
		document.body,
		[
			{
				'scrolled': 90,
				'class': 'scrolled-down'
			}
		]
	);
});


// TODO: should be moved to seperate file (module import style)
// TODO: can use a more modern mobile menu
window.addEventListener('DOMContentLoaded', initMenu, false);

//script vars
var defaultMenuClass;

function initMenu(){
	defaultMenuClass = document.getElementById('wrapper_header').getAttribute('class');
	document.getElementById('menu').addEventListener('click', menuOnClick, false);

	var hoofdMenuElement = document.getElementById('hoofdnavigatie');

	var aElements = hoofdMenuElement.getElementsByTagName('a');
	for(var i=0;i<aElements.length;i++){
		if(aElements[i].getAttribute('href').match(/^\/?#/)){
			aElements[i].addEventListener('click', menuOnClick, false);
		}
	}
}

function menuOnClick(e){
	if (!e) var e = window.event;

	if(e && e.target){
		var target = e.target;
	}
	else if(e && e.srcElement){
		var target = e.srcElement;
	}

	if(document.getElementById('wrapper_header').getAttribute('class') == defaultMenuClass + ' active'){
		document.getElementById('wrapper_header').setAttribute('class', defaultMenuClass);
		document.body.classList.remove('nav-active');
	}
	else if(document.getElementById('wrapper_header').getAttribute('class') == 'active'){
		document.getElementById('wrapper_header').removeAttribute('class');
		document.body.classList.remove('nav-active');
	}
	else if(target == document.getElementById('menu')){
		if(defaultMenuClass){
			document.getElementById('wrapper_header').setAttribute('class', defaultMenuClass + ' active');
			document.body.classList.add('nav-active');
		}
		else {
			document.getElementById('wrapper_header').setAttribute('class', 'active');
			document.body.classList.add('nav-active');
		}
	}
}

window.addEventListener('DOMContentLoaded', function(){
	var screenfull = window.screenfull;
	var panoElement = document.getElementById('pano');
	if(panoElement){
		var autorotateToggleElement = document.querySelector('#autorotateToggle');
		var viewerOpts = {
			controls: {
				//mouseViewMode: 'drag'
			}
		};

		var initialView = {
			yaw: 90 * Math.PI/180,
			pitch: -30 * Math.PI/180,
			fov: 90 * Math.PI/180
		};
		
		//Create view
		var viewer = new Marzipano.Viewer(panoElement, viewerOpts);

		var levels = [
			{ tileSize: 512, size: 512 },
			{ tileSize: 512, size: 1024 }
		];

		var geometry = new Marzipano.EquirectGeometry(levels);
		//create scenes
		var i;
		var x = 1;
		var imageUrl = '';
		var scene_obj = [];
		var source_obj = [];

		for(i = 0; i < imageUrlArray.length; i++ ){
			imageUrl += imageUrlArray[i];
			source_obj[x] = Marzipano.ImageUrlSource.fromString(imageUrlArray[i]);
			var limiter = Marzipano.RectilinearView.limit.traditional(1024, 100*Math.PI/180);
			var view = new Marzipano.RectilinearView({ yaw: Math.PI }, limiter);
			
			
			scene_obj[x] = viewer.createScene({
				source: source_obj[x],
				geometry: geometry,
				view: view,
				pinFirstLevel: true
			});
			x++;
		}

		var autorotate = Marzipano.autorotate({
			yawSpeed: 0.03,
			targetPitch: 0,
			targetFov: Math.PI/2
		});
		
		viewer.startMovement(autorotate);
		viewer.setIdleMovement(3000, autorotate);
		

		setTimeout(function(){
			scene_obj[1].switchTo({
				transitionDuration: 1000
			});
		},2000);

		var element = document.getElementsByClassName('switchScene');
		for(i = 0; i < element.length; i++){
			element[i].addEventListener('click', sceneSwitcher);
		}

		function sceneSwitcher() {
			var whichScene = this.hash.substr(1);

			var element = document.getElementsByClassName('switchScene');
			for(i = 0; i < element.length; i++){
				element[i].classList.remove('active');
			}

			this.classList.add('active');
			
			if (whichScene == 'scene1') { scene_obj[1].switchTo(); }
			if (whichScene == 'scene2') { scene_obj[2].switchTo(); }
			if (whichScene == 'scene3') { scene_obj[3].switchTo(); }
			if (whichScene == 'scene4') { scene_obj[4].switchTo(); }
			if (whichScene == 'scene5') { scene_obj[5].switchTo(); }
			if (whichScene == 'scene6') { scene_obj[6].switchTo(); }
			if (whichScene == 'scene7') { scene_obj[7].switchTo(); }
			if (whichScene == 'scene8') { scene_obj[8].switchTo(); }
			if (whichScene == 'scene9') { scene_obj[9].switchTo(); }
			if (whichScene == 'scene10') { scene_obj[10].switchTo(); }
			
			return false;
		}
	}
});